import { theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors } = theme;

export const progressBar = css`
  background: ${colors.neutralLight};
  border-radius: 0.25rem;
  display: block;
  height: 0.5rem;
  margin: 0 auto 1.25rem;
  width: 100%;
`;

export const progress = css`
  height: 100%;
  background: ${colors.neutralDarker};
  border-radius: 0.25rem;
`;
